import { render, staticRenderFns } from "./ShopSelectionView.vue?vue&type=template&id=fb6b7320&"
import script from "./ShopSelectionView.vue?vue&type=script&lang=ts&"
export * from "./ShopSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./ShopSelectionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6b7320')) {
      api.createRecord('fb6b7320', component.options)
    } else {
      api.reload('fb6b7320', component.options)
    }
    module.hot.accept("./ShopSelectionView.vue?vue&type=template&id=fb6b7320&", function () {
      api.rerender('fb6b7320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopgroups/ShopSelectionView.vue"
export default component.exports